export var getSearchBar = (data, key, searchValue) => {
  var searchTerm = searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase();
  var matches = data === null || data === void 0 ? void 0 : data.filter(item => {
    var _a, _b;
    var searchKey = key;
    var searchSpace = (_b = (_a = item === null || item === void 0 ? void 0 : item.selectionListProps) === null || _a === void 0 ? void 0 : _a.linkListItemProps[searchKey]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    if (searchSpace) return searchSpace === null || searchSpace === void 0 ? void 0 : searchSpace.includes(searchTerm);
  });
  return matches;
};
export var getSearchBarWithMutliKey = (data, keys, searchValue) => {
  var searchTerm = searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase();
  var matches = data === null || data === void 0 ? void 0 : data.filter(item => {
    return keys.some(key => {
      var _a, _b;
      var searchSpace = (_b = (_a = item === null || item === void 0 ? void 0 : item.selectionListProps) === null || _a === void 0 ? void 0 : _a.linkListItemProps[key]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
      return searchSpace === null || searchSpace === void 0 ? void 0 : searchSpace.includes(searchTerm);
    });
  });
  return matches;
};
export var getSuggestionList = (suggestionList, suggestionRegex, searchValue) => {
  var searchTerm = searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase();
  var matches = suggestionList;
  var searchValueSplit = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.split(new RegExp(suggestionRegex, 'g'));
  if (searchValueSplit.length > 1) {
    var searchSpace = searchValueSplit[searchValueSplit.length - 1];
    matches = suggestionList === null || suggestionList === void 0 ? void 0 : suggestionList.filter(item => {
      var _a;
      var itemLabel = (_a = item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase();
      if (searchSpace) {
        return itemLabel === null || itemLabel === void 0 ? void 0 : itemLabel.includes(searchSpace);
      } else {
        return true;
      }
    });
  }
  return matches;
};
export var getSearchValue = (selectedSuggestion, searchValue, suggestionRegex) => {
  if (!!suggestionRegex && !!searchValue) {
    var _searchValue$split = searchValue.split(new RegExp(suggestionRegex, 'g')),
      upiPrefix = _searchValue$split[0];
    if (upiPrefix) return upiPrefix + suggestionRegex + selectedSuggestion;
  }
  return selectedSuggestion;
};